import React, { Component } from "react";
import classNames from "classnames";
import StatusMessage from "assets/scripts/components/presentational/StatusMessage";
const LOAD_CALLBACK = "captchaLoaded2b2c353738";
const SITE_KEY = process.env.NODE_ENV === "production"
    ? window.DCM_SETTINGS.CAPTCHA_KEY
    : "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
let loaded = false;
const recaptchaLoadPromise = new Promise(resolve => {
    window[LOAD_CALLBACK] = function loadCallback() {
        delete window[LOAD_CALLBACK];
        loaded = true;
        resolve();
    };
    const tag = document.createElement("script");
    tag.type = "text/javascript";
    tag.src = `https://www.google.com/recaptcha/api.js?render=explicit&onload=${LOAD_CALLBACK}`;
    document.head.appendChild(tag);
});
class Captcha extends Component {
    constructor(props, context) {
        super(props, context);
        this._id = null;
        this._isMounted = true;
        this._element = null;
        this.state = {
            loaded
        };
        this._updateElement = this._updateElement.bind(this);
    }
    async componentDidMount() {
        if (this.state.loaded) {
            this._tryInit();
        }
        if (!this.state.loaded) {
            await recaptchaLoadPromise;
            if (this._isMounted) {
                this.setState({ loaded: true });
            }
        }
    }
    componentDidUpdate() {
        this._tryInit();
    }
    componentWillUnmount() {
        this._isMounted = false;
        this._tryInit();
    }
    _updateElement(element) {
        this._element = element;
        if (element == null
            && this._id != null) {
            grecaptcha.reset(this._id);
            this._id = null;
            this.props.onChange(null);
        }
    }
    _tryInit() {
        if (this.state.loaded
            && this.props.required
            && this._id == null
            && this._element != null) {
            this._id = grecaptcha.render(this._element, {
                sitekey: SITE_KEY,
                callback: (response) => this.props.onChange(response),
                "expired-callback": () => this.props.onChange(null)
            });
            this.props.onChange(null);
        }
    }
    render() {
        const { props, state } = this;
        if (!props.required) {
            return null;
        }
        if (!state.loaded) {
            return (<div className="form-group" data-test="captcha">
					<StatusMessage isLoad isActive/>
				</div>);
        }
        return (<div ref={this._updateElement} className={classNames("form-group", {
            "form-group_isDisabled": !props.required
        })} data-test="captcha"/>);
    }
    reset() {
        if (this._id != null) {
            grecaptcha.reset(this._id);
        }
        this.props.onChange(null);
    }
}
export default Captcha;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/Captcha/Captcha.tsx